module.exports = __webpack_public_path__ + "static/media/favicon.a031bdae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/favicon.svg
// module id = 924
// module chunks = 0